const levels = [];
const passwords = [];
passwords[0] = "aajh";
levels[0] = [
    "                   ",
    "                   ",
    "    11111          ",
    "    1   1          ",
    "    1a  1          ",
    "  111  a11         ",
    "  1  a a 1         ",
    "111 1 11 1   111111",
    "1   1 11 11111  xx1",
    "1 a  a          xx1",
    "11111 111 1#11  xx1",
    "    1     111111111",
    "    1111111        ",
    "                   ",
    "                   ",
    "                   ",
];
passwords[1] = "hhwe";
levels[1] = [
    "                   ",
    "                   ",
    "                   ",
    "  111111111111     ",
    "  1xx  1     111   ",
    "  1xx  1 a  a  1   ",
    "  1xx  1a1111  1   ",
    "  1xx    # 11  1   ",
    "  1xx  1 1  a 11   ",
    "  111111 11a a 1   ",
    "    1 a  a a a 1   ",
    "    1    1     1   ",
    "    111111111111   ",
    "                   ",
    "                   ",
    "                   ",
];
passwords[2] = "232d";
levels[2] = [
    "                   ",
    "                   ",
    "                   ",
    "         11111111  ",
    "         1     #1  ",
    "         1 a1a 11  ",
    "         1 a  a1   ",
    "         11a a 1   ",
    " 111111111 a 1 111 ",
    " 1xxxx  11 a  a  1 ",
    " 11xxx    a  a   1 ",
    " 1xxxx  1111111111 ",
    " 11111111          ",
    "                   ",
    "                   ",
    "                   ",
];
passwords[3] = "bh2d";
levels[3] = [
    "           11111111",
    "           1  xxxx1",
    "111111111111  xxxx1",
    "1    1  a a   xxxx1",
    "1 aaa1a  a 1  xxxx1",
    "1  a     a 1  xxxx1",
    "1 aa 1a a a11111111",
    "1  a 1     1       ",
    "11 111111111       ",
    "1    1    11       ",
    "1     a   11       ",
    "1  aa1aa  #1       ",
    "1    1    11       ",
    "11111111111        ",
    "                   ",
    "                   ",
];
passwords[4] = "rrh7";
levels[4] = [
    "                   ",
    "        11111      ",
    "        1   11111  ",
    "        1 1a11  1  ",
    "        1     a 1  ",
    "111111111 111   1  ",
    "1xxxx  11 a  a111  ",
    "1xxxx    a aa 11   ",
    "1xxxx  11a  a #1   ",
    "111111111  a  11   ",
    "        1 a a  1   ",
    "        111 11 1   ",
    "          1    1   ",
    "          111111   ",
    "                   ",
    "                   ",
];
passwords[5] = "ssk1";
levels[5] = [
    "                   ",
    "                   ",
    "   222222  222     ",
    "   2xx  2 22#22    ",
    "   2xx  222   2    ",
    "   2xx     aa 2    ",
    "   2xx  2 2 a 2    ",
    "   2xx222 2 a 2    ",
    "   2222 a 2a  2    ",
    "      2  a2 a 2    ",
    "      2 a  a  2    ",
    "      2  22   2    ",
    "      222222222    ",
    "                   ",
    "                   ",
    "                   ",
];
passwords[6] = "pol1";
levels[6] = [
    "                   ",
    "        22222      ",
    "  2222222   22     ",
    " 22 2 #22 aa 2     ",
    " 2    a      2     ",
    " 2  a  222   2     ",
    " 222 22222a222     ",
    " 2 a  222 xx2      ",
    " 2 a a a xxx2      ",
    " 2    222xxx2      ",
    " 2 aa 2 2xxx2      ",
    " 2  222 22222      ",
    " 2222              ",
    "                   ",
    "                   ",
    "                   ",
];
// passwords[34] = "bh2d";
// levels[34] = [
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
// ];

export default {levels, passwords};
